export default "__VITE_ASSET__D4CJYdzE__"